import { MeasureForm } from '@lidea/analysis/desktop/shared/ui';
import { useMeasure } from '@lidea/shared/data-access/analysis';
import { MutationWithContext } from '@lidea/shared/data-access/core';

interface UpdateMeasurePreviewProps {
  measureId: number;
  fieldId: number;
  mutation: MutationWithContext;
}

export const UpdateMeasurePreview: React.FC<UpdateMeasurePreviewProps> = ({
  measureId,
  fieldId,
  mutation,
}) => {
  const measure = useMeasure({ measureId });

  if (!measure.data) {
    return null;
  }

  return (
    <MeasureForm
      defaultValues={(mutation.state.variables as any).data}
      fields={{
        static: measure.data.static,
        dynamic: measure.data.dynamic,
      }}
      i18n={{
        submit: '',
      }}
      measureId={measureId}
      measureZone={measure.data.point.properties.zone}
      plotId={fieldId.toString()}
      readonly
      onSubmit={() => null}
    />
  );
};
